import { FETCH_COUNTRY_SUCCESS, FETCH_COUNTRY_REQUEST, FETCH_COUNTRY_FAILURE } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const countryReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COUNTRY_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_COUNTRY_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_COUNTRY_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        default:
            return state;
    }
};
export default countryReducer;
